module.exports = __webpack_public_path__ + "static/media/xnk.7db88ae4.png";